import { render, staticRenderFns } from "./ScreenshotsList.vue?vue&type=template&id=1f895a03&scoped=true&"
import script from "./ScreenshotsList.vue?vue&type=script&lang=js&"
export * from "./ScreenshotsList.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotsList.vue?vue&type=style&index=0&id=1f895a03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f895a03",
  null
  
)

export default component.exports